import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=2238add8&scoped=true&"
import script from "./CloseButton.vue?vue&type=script&lang=js&"
export * from "./CloseButton.vue?vue&type=script&lang=js&"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=2238add8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2238add8",
  null
  
)

export default component.exports